customElements.get("cart-alerts") || customElements.define("cart-alerts", class extends HTMLElement {
  async loadNotification(t) {
    const e = await fetch(`${location.pathname}?sections=cart-notification-product`), n = await e.json();
    for (const [, e] of Object.entries(n)) {
      if (!e) continue;
      const n = (new DOMParser).parseFromString(e, "text/html").querySelector('[id="shopify-section-cart-notification-product"] cart-notification');
      if (!n) continue;
      const i = n.querySelector(`[data-key="cart-notification-product-${t}"]`);
      i && (i.classList.remove("hidden"), i.classList.add("flex"), this.appendChild(n), 
      this.manageNotificationOverflow());
    }
  }
  manageNotificationOverflow() {
    requestAnimationFrame(() => setTimeout(() => {
      const t = this.querySelectorAll('cart-notification[aria-hidden="false"]');
      if (!t.length) return;
      const e = t[t.length - 1];
      if (e.getBoundingClientRect().bottom > window.innerHeight) {
        const n = t[0];
        n?.hide && n !== e && (n.hide(), setTimeout(() => this.manageNotificationOverflow(), 100));
      }
    }, 100));
  }
  connectedCallback() {
    this.openOnAdd = !1, this.handleSettings = t => {
      this.openOnAdd = t.detail?.openOnAdd;
    }, window.addEventListener("cart:settings", this.handleSettings), window.dispatchEvent(new CustomEvent("cart:settings-request")), 
    this.handleCartAdded = t => {
      if (document.getElementById("Cart").checked || this.openOnAdd) return;
      const e = t.detail?.item?.key || t.detail?.item?.items?.[0]?.key;
      e && this.loadNotification(e);
    }, window.addEventListener("cart:added", this.handleCartAdded);
    const t = this.closest("header").querySelector("notification-card"), e = this;
    if (!t || !e) return;
    const n = t.querySelector('input[type="checkbox"][id="notification-card"]'), {height: i} = t.getBoundingClientRect(), a = getComputedStyle(t), o = i + (parseInt(a.marginTop, 10) || 0) + (parseInt(a.marginBottom, 10) || 0), d = window.matchMedia("(min-width: 1024px)"), c = t => {
      d.matches ? e.style.marginTop = t ? `${Math.round(o)}px` : null : e.style.marginTop = null;
    };
    c(n.checked), window.addEventListener("notification_card_change", t => c(t.detail.checked)), 
    d.addEventListener("change", () => c(n.checked));
  }
  disconnectedCallback() {
    window.removeEventListener("cart:added", this.handleCartAdded), window.removeEventListener("cart:settings", this.handleSettings);
  }
});